module.exports = __webpack_public_path__ + "static/img/054.07bd7323.png";